<template>
  <body id="app" :dir="dir" :lang="lang">
    <noscript>
      <strong>
        We're sorry but Pishkhan doesn't work properly without JavaScript
        enabled. Please enable it to continue.
      </strong>
    </noscript>

    <!-- route outlet -->
    <!-- component matched by the route will render here -->
    <Loading
      v-show="appLoading || !$auth.ready"
      class="app__loading"
      height="100%"
    />

    <!-- the global modal component, its contents will set via store action -->
    <ModalDialog />

    <RouterView v-if="$auth.ready" v-title="$t(title)" />
  </body>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  TITLE,
  LANGUAGE,
  DIRECTION,
  INIT_LANGUAGE,
  LOADING,
} from '@/store/types';

import title from './directives/pageTitle';

import Loading from '@@/common/Loading';
import ModalDialog from './plugins/modal/ModalDialog';

export default {
  name: 'App',
  // sets the language on initial load
  components: {
    Loading,
    ModalDialog,
  },
  directives: {
    title,
  },

  computed: {
    ...mapGetters({
      dir: DIRECTION,
      title: TITLE,
      lang: LANGUAGE,
      appLoading: LOADING,
    }),
  },
  created() {
    this.initialLanguage();
    // set the page title
    this.setTitle('PISHKHAN');
  },
  methods: {
    ...mapActions({
      initialLanguage: INIT_LANGUAGE,
      setTitle: TITLE,
    }),
  },
};
</script>

<style lang="scss">
@import '../../../libs/shared-assets/src/fonts/fonts.scss';
// Loebat stylesheets
@import './stylesheets/modules/modules';
@import './stylesheets/layout';
@import './stylesheets/locale';
// Foundation sites
@import './stylesheets/foundation/foundation';
@include foundation-everything(true);
@import './stylesheets/element-theme/base.css';
@import './stylesheets/helpers/helpers';
@import './stylesheets/new-design';

.app__loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
}
</style>
